define('services/nutrition/entry-tag',[
    'underscore', 'backbone', 'utils',
    // parent
    'src/service',
    // models & collections
    'collections/calendar/nutrition/entry-tags',
    'models/calendar/nutrition/entry-tag'
], function(
    _, Backbone, U,
    // parent
    Service,
    // models & collections
    CEntryTags,
    MEntryTag
) {

    var EntryTagService = Service.extend({
        initialize: function() {
            this.model = new MEntryTag();
            this.collection = new CEntryTags();
        },

        onSync: function() {
            this.collection.reset(this.model.attributes, { parse: true });
        },

        getText: function(tag) {
            return this.model.get(tag);
        },

    });

    return new EntryTagService();
});

